module.exports = __webpack_public_path__ + "img/1592904485.858d0355.jpg";